<i2a-profile-page [profile]="profile" [template]="template" [alertIsSent]="alertIsSent" [(profileIsValidated)]="profileIsValidated"
                  [configuration]="template.configuration" [resources]="resources" [userActivityIsValid]="userActivityIsValid" [warningshighlighting]="warnings">
  <ng-container profile> 
    <ng-template #templateModules i2a-container></ng-template>
    <ng-template  #user i2a-container ></ng-template>
    <div [id]="id" class="id-resources">
      <ng-template #provider i2a-container ></ng-template>
    </div>
  </ng-container>
</i2a-profile-page>